export default "__VITE_ASSET__DjrEFDgD__"